// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.text-column[data-v-73767502] {\n  text-align: left;\n  cursor: pointer;\n}\n.number-column[data-v-73767502] {\n  text-align: right;\n}\n", ""]);
// Exports
module.exports = exports;
